import { render, staticRenderFns } from "./MonthSummaryItems.vue?vue&type=template&id=f55da4ba&scoped=true"
import script from "./MonthSummaryItems.vue?vue&type=script&lang=js"
export * from "./MonthSummaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55da4ba",
  null
  
)

export default component.exports